module.exports = __webpack_public_path__ + "img/icon_dean_home_bg_card_1.c2eed8bb.png";